var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2V6H30V2H34V6H42C43.1046 6 44 6.89544 44 8V40C44 41.1046 43.1046 42 42 42H6C4.89544 42 4 41.1046 4 40V8C4 6.89544 4.89544 6 6 6H14V2H18ZM40 22H8V38H40V22ZM22 26V34H12V26H22ZM14 10H8V18H40V10H34V14H30V10H18V14H14V10Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCalendarIcon);
export default __webpack_public_path__ + "static/media/BlueCalendarIcon.f74795b042efa71b80b47a54a9ea974b.svg";
export { ForwardRef as ReactComponent };